import { EntityHistoryService } from '@/openapi';

export function useTrackRecording() {
  const fetchRecords = async (entityId: string) => {
    try {
      return await EntityHistoryService.entityHistoryClientControllerV1FindAllV1(entityId);
    } catch (err) {
      console.log(err);
    }
  };

  return {
    fetchRecords,
  };
}
